/**
 * KnowledgebaseContentSearch
 */
export enum KnowledgebaseContentSearch {
    ARTICLES = 'articles',
    FILES = 'files'
}
